import { FunctionComponent, useCallback } from "react";

import {
	CompanyEnrichAutoComplete,
	CompanyEnrichAutoCompleteItem,
} from "@/pages/Private/pages/CompanyEnrich/components/CompanyEnrichAutoComplete";
import { useGetGeoCountriesMutation } from "@/pages/Private/redux/companyEnrich/companyEnrich.api";

interface CountryMultiSelectProps {
	selectedNames: string[];
	onChange: (names: string[]) => void;
	label?: string;
	placeholder?: string;
}

export const CountryMultiSelect: FunctionComponent<CountryMultiSelectProps> = ({
	selectedNames,
	onChange,
	label = "",
	placeholder,
}) => {
	const [getGeoCountries] = useGetGeoCountriesMutation();

	const fetchCountries = useCallback(
		async (query: string): Promise<CompanyEnrichAutoCompleteItem[]> => {
			const result = await getGeoCountries({ query }).unwrap();

			return result.items.map((item) => ({ id: item.name, title: item.name }));
		},
		[getGeoCountries]
	);

	const selectedItems = selectedNames.map((name) => ({ id: name, title: name }));

	return (
		<CompanyEnrichAutoComplete
			fetchFn={fetchCountries}
			handleSelect={(value) => {
				const names = (value ?? []).map((item) => item.id);

				onChange(names);
			}}
			label={label}
			placeholder={placeholder}
			selectedItems={selectedItems}
			stayOn
		/>
	);
};
